

// import Home from './Components/Home';
// import About from './Components/About';
// import Corecommitee from './Components/Corecommitee';
// import Gallery from './Components/Gallery';
// import Events from './Components/Events';
// import Donation from './Components/Donation';
// import { Route, Routes } from 'react-router-dom';
// import Projects from './Components/Projects';
// import Register from './Components/Register';
// function App() {
//   return (
//     <>
//       <Routes>
//         <Route path='/' element={<Home />} />
//         <Route path='/about' element={<About />} />
//         <Route path='/corecommittee' element={<Corecommitee />} />
//         <Route path='/donation' element={<Donation />} />
//         <Route path='/gallery' element={<Gallery />} />
//         <Route path='/event' element={<Events />} />
//         <Route path='/project' element={<Projects />} />
//         <Route path='/contact' element={<Events />} />
//         <Route path='/register' element={<Register />} />
//       </Routes>


//     </>
//   );
// }

// export default App;
import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import 'aos/dist/aos.css';
import AOS from 'aos';

import Home from './Components/Home';
import About from './Components/About';
import Corecommitee from './Components/Corecommitee';
import Gallery from './Components/Gallery';
import Events from './Components/Events';
import Donation from './Components/Donation';
import Projects from './Components/Projects';
import Register from './Components/Register';
import Preloader from './Components/Preloader';
import Contactus from './Components/Contactus';
import Career from './Components/Career';
import PrivacyPolicy from './Components/PrivacyPolicy';
import Lhic from './Components/Lhic';

function App() {
  const [loading, setLoading] = useState(true);
  const [fadeOut, setFadeOut] = useState(false);
  const location = useLocation();

  useEffect(() => {
  AOS.init({
    duration: 1000,      // Animation duration in ms
    once: true,          // Only animate once
    offset: 100,         // Trigger animation 100px before the element
  });
}, []);
  // Handle loader on route change
  useEffect(() => {
    setLoading(true);
    setFadeOut(false);

    const timer1 = setTimeout(() => setFadeOut(true), 1000);
    const timer2 = setTimeout(() => setLoading(false), 1700);
    const failsafe = setTimeout(() => setLoading(false), 4000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(failsafe);
    };
  }, [location]);

  return (
    <>
      <div
        className={loading ? 'app-shell app-shell--loading' : 'app-shell'}
        aria-hidden={loading}
      >
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/membership' element={<Corecommitee />} />
          {/* Old route — redirects to /membership */}
          <Route path='/corecommittee' element={<Navigate to="/membership" replace />} />
          <Route path='/donation' element={<Donation />} />
          <Route path='/gallery' element={<Gallery />} />
          <Route path='/event' element={<Events />} />
          <Route path='/project' element={<Projects />} />
          <Route path='/contact' element={<Events />} />
          <Route path='/register' element={<Register />} />
          <Route path='/contactus' element={<Contactus />} />
          <Route path='/career' element={<Career />} />
          <Route path='/privacy-policy' element={<PrivacyPolicy />} />
          <Route path='/lhic' element={<Lhic />} />
        </Routes>
      </div>

      {loading && <Preloader fadeOut={fadeOut} />}
    </>
  );
}

export default App;
